import React from "react";
import { Link, Navigate } from "react-router-dom";
import {
  PlatzApiErrorErrorCode,
  SpotifyTrackSourceOptionView,
  useGetSpotifyTopTracks,
} from "../api-generated";
import { getPlatzApiError } from "../utils";
import Button from "./Button";
import ErrorLoading from "./ErrorLoading";
import CenteredLoading from "./CenteredLoading";
import { SPOTIFY_OAUTH_LOGIN_ROUTE } from "../routes";
import Table from "./Table";

interface TrackBeingSearchedFor {
  ppid: string;
  name: string;
  artistNames: string[];
}

async function sendDataToExtension(data: any) {
  console.log("posting message to window for content script: ", data);
  window.postMessage(
    {
      type: "SEND_EXTENSION_DATA",
      action: "saveData",
      data: data,
    },
    "*"
  );
}

async function getDataFromExtension() {
  return new Promise((resolve) => {
    // Create a message listener
    const messageHandler = (event: any) => {
      if (event.data.type === "EXTENSION_DATA_RESPONSE") {
        // Remove the listener to prevent memory leaks
        window.removeEventListener("message", messageHandler);
        resolve(event.data.data);
      }
    };

    // Add the listener
    window.addEventListener("message", messageHandler);

    // Send request to extension
    window.postMessage(
      {
        type: "GET_EXTENSION_DATA",
        action: "getData",
      },
      "*"
    );
  });
}

const SpotifyTopTracks: React.FC = () => {
  const { data, error, isLoading } = useGetSpotifyTopTracks();

  if (isLoading) {
    return <CenteredLoading />;
  }

  if (error) {
    const platzApiError = getPlatzApiError(error);
    if (
      platzApiError?.errorCode === PlatzApiErrorErrorCode.spotify_unauthorized
    ) {
      return <Navigate to={SPOTIFY_OAUTH_LOGIN_ROUTE} />;
    }
    return <ErrorLoading error={error} />;
  }

  const searchLyricsOnGoogle = (track: SpotifyTrackSourceOptionView): void => {
    const googleQuery = `${track.trackName} ${track.trackArtists
      .map((a) => a.name)
      .join(" ")} lyrics`.replaceAll(" ", "+");
    const url = `https://www.google.com/search?q=${googleQuery}&sourceid=chrome&ie=UTF-8`;
    const trackBeingSearchedFor: TrackBeingSearchedFor = {
      ppid: track.trackId,
      name: track.trackName,
      artistNames: track.trackArtists.map((a) => a.name),
    };
    console.log("saving json here", trackBeingSearchedFor);
    sendDataToExtension(trackBeingSearchedFor);

    //TODO: this should be an abstraction - maybe from useLocalStorage
    //window.localStorage.setItem(
    //  "track-being-searched-for",
    //  JSON.stringify(trackBeingSearchedFor)
    //);

    //chrome.storage.local.set(
    //  { "track-being-searched-for": JSON.stringify(trackBeingSearchedFor) },
    //  () => {
    //    console.log("Data saved.");
    //  }
    //);

    const secondTab = window.open(url, "_blank");
    if (secondTab) {
      secondTab.focus();
    }
  };

  const columns = [
    {
      columnName: "Name",
      getContent: (row: SpotifyTrackSourceOptionView) => (
        <div>{row.trackName}</div>
      ),
    },
    {
      columnName: "Ahtists",
      getContent: (row: SpotifyTrackSourceOptionView) => (
        <div>{row.trackArtists?.map((ahtist) => ahtist.name).join(", ")}</div>
      ),
    },
    {
      columnName: "Actions",
      getContent: (row: SpotifyTrackSourceOptionView) => {
        //TODO: util for getting source route
        const classes = "hover:underline cursor-pointer text-sm";
        if (row.sourceId !== null) {
          return (
            //TODO: this hard-coding
            <Link to={`/sources/googled_lyrics/${row.sourceId}`}>
              <span className={classes}>Go to Source</span>
            </Link>
          );
        }
        return (
          <Button
            label="Google Lyrics"
            onClick={() => searchLyricsOnGoogle(row)}
            type="primary"
          />
        );
      },
    },
  ];

  return (
    <div>
      <div className="pb-6">
        <h1 className="text-xl font-bold">Enforschen</h1>
      </div>
      <Table
        columns={columns}
        rows={data}
        //navigateOnClick={(track, rowIndex) => {}}
      />
    </div>
  );
};

export default SpotifyTopTracks;
